export const animateScroll = (selector, speed, offset) => {
    $([document.documentElement, document.body]).animate({
        scrollTop: $(selector).offset().top - (offset)
    }, speed);
}
